import api from './api';

const BASE = '/api/friends';

export const getFriends = async () => {
  const response = await api.get(BASE);
  return response.data || [];
};

export const searchUsers = async (query) => {
  const response = await api.get(`${BASE}/search`, { params: { q: query } });
  return response.data || [];
};

export const sendFriendRequest = async (recipientId) => {
  const response = await api.post(`${BASE}/requests/${recipientId}`);
  return response.data;
};

export const getFriendRequests = async () => {
  const response = await api.get(`${BASE}/requests`);
  return response.data || { incoming: [], outgoing: [] };
};

export const acceptFriendRequest = async (requestId) => {
  const response = await api.post(`${BASE}/requests/${requestId}/accept`);
  return response.data;
};

export const declineFriendRequest = async (requestId) => {
  const response = await api.post(`${BASE}/requests/${requestId}/decline`);
  return response.data;
};

export const cancelFriendRequest = async (requestId) => {
  const response = await api.post(`${BASE}/requests/${requestId}/cancel`);
  return response.data;
};

export const removeFriend = async (friendId) => {
  await api.delete(`${BASE}/${friendId}`);
};
